import { Box, Link as MuiLink, Stack } from '@mui/material';
import FormSection from 'components/form-section/form-section.component';
import NumericStepInputField from 'components/forms/fields/numeric-step-input-field/numeric-step-input-field.component';
import { useLocationForm } from 'components/forms/location/location-form.hooks';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

const DefaultPreparationTime = () => {
  const { t } = useTranslation();
  const { locationId } = useParams();
  const { data } = useLocationForm(locationId);

  return (
    <Box mb={2} className="field-container">
      <FormSection
        title={t(
          'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.title',
        )}
        subtitle={t(
          'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.subtitle',
        )}
      >
        <Box
          display="grid"
          justifyContent="space-between"
          gridTemplateColumns={{ xs: '1fr', sm: '1fr', lg: '1fr 1fr' }}
          gap={{ xs: 0, lg: 2 }}
        >
          <NumericStepInputField
            name="ordering.pickupOrderProcessingTime"
            id="defaultPickupPrepTime"
            label={t(
              'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultPickupPrepTime.label',
            )}
            step={1}
            suffix={t(
              'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultPickupPrepTime.suffix',
            )}
            helperText={
              !data?.ordering?.pickupOrdersAccepted && (
                <Stack
                  display="flex"
                  direction="row"
                  spacing={0.5}
                  data-testid="DefaultPickupPrepTime.HelperText"
                >
                  <Box component="span">
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultPickupPrepTime.helperText.text1',
                    )}
                  </Box>
                  <MuiLink component={Link} to="../../pickup" color="secondary">
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultPickupPrepTime.helperText.link',
                    )}
                  </MuiLink>
                  <Box component="span">
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultPickupPrepTime.helperText.text2',
                    )}
                  </Box>
                </Stack>
              )
            }
            data-testid="PreparationTime.Pickup.DefaultPickupPrepTimeField"
            allowNegative={false}
            allowDecimal={false}
            decrementDisabled={val => {
              return val < 2;
            }}
            incrementDisabled={val => {
              return val > 1438;
            }}
          />
          <NumericStepInputField
            name="ordering.deliveryOrderProcessingTime"
            id="defaultDeliveryPrepTime"
            label={t(
              'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultDeliveryPrepTime.label',
            )}
            step={1}
            suffix={t(
              'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultDeliveryPrepTime.suffix',
            )}
            helperText={
              !data?.ordering?.deliveryOrdersAccepted && (
                <Stack
                  display="flex"
                  direction="row"
                  spacing={0.5}
                  data-testid="DefaultDeliveryPrepTime.HelperText"
                >
                  <Box component="span">
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultDeliveryPrepTime.helperText.text1',
                    )}
                  </Box>
                  <MuiLink
                    component={Link}
                    to="../../delivery"
                    color="secondary"
                  >
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultDeliveryPrepTime.helperText.link',
                    )}
                  </MuiLink>
                  <Box component="span">
                    {t(
                      'page.locations.edit.tabs.ordering.sections.kitchenCapacity.tabs.prepTime.defaultPreparationTime.fields.defaultDeliveryPrepTime.helperText.text2',
                    )}
                  </Box>
                </Stack>
              )
            }
            data-testid="PreparationTime.Delivery.DefaultDeliveryPrepTimeField"
            allowNegative={false}
            allowDecimal={false}
            decrementDisabled={val => {
              return val < 2;
            }}
            incrementDisabled={val => {
              return val > 1438;
            }}
          />
        </Box>
      </FormSection>
    </Box>
  );
};

export default DefaultPreparationTime;
